import React from 'react';

import UFOLabel from '@atlaskit/react-ufo/label';
import { NavErrorBoundary } from '@atlassian/navigation-error-boundary';

import {
	GLOBAL_MORE_MENU_INTERACTION_ID,
	GLOBAL_MORE_MENU_INTERACTION_NAME,
} from '../common/constants';
import { AsyncIntlProvider } from '../common/utils/locale';
import type { GlobalMoreMenuProps } from '../types';

import { messages } from './messages';
import { MoreMenuPopup } from './more-menu-popup';
import { getHiddenItems } from './utils/get-hidden-items';

export function GlobalMoreMenu(props: GlobalMoreMenuProps): React.JSX.Element {
	const { intlMode } = props;

	return (
		<AsyncIntlProvider disabled={intlMode === 'inherit'}>
			<UFOLabel name={GLOBAL_MORE_MENU_INTERACTION_NAME}>
				<NavErrorBoundary
					errorMessages={messages}
					interactionId={GLOBAL_MORE_MENU_INTERACTION_ID}
					intlMode={intlMode}
					showFlags
				>
					<GlobalMoreMenuInner {...props} />
				</NavErrorBoundary>
			</UFOLabel>
		</AsyncIntlProvider>
	);
}

function GlobalMoreMenuInner({
	productItemsData,
	appItemsData = [],
	menuItemComponent,
	customizeSidebarMenuItem,
	moreMenuItemLabel,
	peekingMenuIds = [],
	onClickMoreMenuTrigger,
	testId,
	triggerRef,
	triggerVisualContentRef,
	dropIndicator,
}: GlobalMoreMenuProps): React.JSX.Element {
	const { hiddenProductItemsData, hiddenAppItemsData, shouldShowMoreMenu } = getHiddenItems(
		productItemsData,
		appItemsData,
		peekingMenuIds,
	);

	return (
		<MoreMenuPopup
			appItemsData={hiddenAppItemsData}
			customizeSidebarMenuItem={customizeSidebarMenuItem}
			dropIndicator={dropIndicator}
			menuItemComponent={menuItemComponent}
			moreMenuItemLabel={moreMenuItemLabel}
			onClickMoreMenuTrigger={onClickMoreMenuTrigger}
			productItemsData={hiddenProductItemsData}
			showMoreMenu={shouldShowMoreMenu}
			testId={testId}
			triggerRef={triggerRef}
			triggerVisualContentRef={triggerVisualContentRef}
		/>
	);
}
